import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-12\"><h2 class=\"fw-bolder text-dark\">PHI</h2></div><div class=\"mb-2\"><label class=\"form-label\">Protected health information(PHI) is defined as: </label></div><div class=\"text-gray-400 fw-bold mb-2 fs-6\"> 1. identifies or could be used to identify an individual; </div><div class=\"text-gray-400 fw-bold mb-2 fs-6\"> 2. is created or received by a healthcare provider, health plan, employer or healthcare clearinghouse; and </div><div class=\"text-gray-400 fw-bold mb-10 fs-6\"> 3. relates to the past, present or future physical or mental health or condition of an individual; the provision of health care to an individual; or the past, present or future payment for the provision of healthcare to an individual. </div>", 5)
const _hoisted_9 = { class: "fv-row" }
const _hoisted_10 = { class: "d-flex flex-stack" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createTextVNode("Will any protected health information (PHI) be accessed or extracted from medical records for your study? "),
    /*#__PURE__*/_createElementVNode("span", null, " See definition of PHI below. ")
  ])
], -1)
const _hoisted_12 = { class: "form-check form-switch form-check-custom form-check-solid mb-7 me-4" }
const _hoisted_13 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "fv-row mb-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " How will you be accessing subject PHI? ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "Hospital System" }, "Hospital System", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "Outpapient Office" }, "Outpapient Office", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "Others(Please Specify)" }, " Others(Please Specify) ", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Others(Please Specify) ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("label", _hoisted_12, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "willAccessFromRecord",
              value: "1",
              modelValue: _ctx.step2.willAccessFromRecord,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step2.willAccessFromRecord) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.step2.willAccessFromRecord == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      (_ctx.step2.willAccessFromRecord === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("select", {
                name: "accessType",
                "data-control": "select2",
                "data-hide-search": "true",
                class: "form-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step2.accessType) = $event))
              }, _hoisted_20, 512), [
                [_vModelSelect, _ctx.step2.accessType]
              ]),
              _createVNode(_component_Field, {
                type: "hidden",
                name: "accessType",
                class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                placeholder: "How it will be record?",
                modelValue: _ctx.step2.accessType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step2.accessType) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "accessType",
                class: "fv-plugins-message-container invalid-feedback"
              })
            ]),
            (_ctx.step2.accessType === 'Others(Please Specify)')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_editor, {
                    for: "accessTypeOther",
                    initialValue: "step2.accessTypeOther",
                    modelValue: _ctx.step2.accessTypeOther,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step2.accessTypeOther) = $event)),
                    licenseKey: "gpl",
                    "api-key": _ctx.currentEditorToken,
                    init: {
              height: 200,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
                  }, null, 8, ["modelValue", "api-key"]),
                  _createVNode(_component_Field, {
                    type: "hidden",
                    name: "accessTypeOther",
                    class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                    placeholder: "How it will be record?",
                    modelValue: _ctx.step2.accessTypeOther,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step2.accessTypeOther) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "accessTypeOther",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}